import { useLayoutEffect, useReducer } from "react";
import "./App.css";
import LoginComponent from "./components/Common/LoginComponent";
import Cookies from "universal-cookie";
import NavigationComponent from "./components/Common/NavigationComponent";
import {
  authUrlsReducer,
  initialUrlsSate,
} from "./context/reducer/authUrlsReducer";
import { AuthUrlContext } from "./context/createContext";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("at");
    const directLogin = urlParams.get("dl");
    const restaurantId = urlParams.get("restaurantId");
   
    useLayoutEffect(() => {
      if (authToken) {
       const cookies = new Cookies();
       let d = new Date();
   
       d.setTime(d.getTime() + 9 * 60 * 60 * 1000);
       cookies.set("loginData1", {accessToken: authToken , directLogin : directLogin, restaurantId : restaurantId}, { path: "/", expires: d });
       cookies.set("pyAuth", authToken, {
           path: "/",
           expires: d,
       });
      }
    }, [])

  const [userRights, dispatchUserRights] = useReducer(
    authUrlsReducer,
    initialUrlsSate
  );
  const cookies = new Cookies();

  if (cookies.get("loginData1") === undefined && !directLogin) {
    return (
      <div>
        <LoginComponent />
      </div>
    );
  } else {
    return (
      <AuthUrlContext.Provider value={{ userRights, dispatchUserRights }}>
        <div className="h-100">
          <div className="page-loader-wrapper">
            <div className="loader">
              <div className="page-loader-wrapper" style={{ display: "none" }}>
                <div className="loader">
                  <div className="bar1"></div>
                  <div className="bar2"></div>
                  <div className="bar3"></div>
                  <div className="bar4"></div>
                  <div className="bar5"></div>
                </div>
              </div>
            </div>
          </div>
          {/* <div id="wrapper">
            <nav
              className="navbar navbar-fixed-top"
              style={{ padding: "0" }}
            ></nav>
            <div id="megamenu" className="megamenu vivify driveInTop"></div>
            <div id="rightbar" className="rightbar"></div>
            <div id="left-sidebar" className="sidebar">
              <div className="sidebar-scroll">
                <div className="user-account"></div>
                <nav id="left-sidebar-nav" className="sidebar-nav"></nav>
              </div>
            </div>
          </div> */}
          
          <NavigationComponent />
        </div>
      </AuthUrlContext.Provider>
    );
  }
}

export default App;
